import { isInternalUser } from "lib/entitlements";
import { unqiueElems } from "lib/utils";
import { i18n } from "app/i18n/i18n";
import { features } from "app/features";

export function parseFaqItems(json) {
  try {
    const lang = i18n.getLanguage();
    const data = (json && json.data) || [];
    const faqItems = !isInternalUser() ? removeAdminFaqContent(data) : data;
    if (features.sortFaqBySortField) faqItems.sort(sortFaq);
    const categories = faqItems.map((faqItem) => faqItem["category_" + lang]);
    return [faqItems, unqiueElems(categories)];
  } catch (err) {
    console.error("Error parsing faq items", err);
    return [[], [], true];
  }
}

const removeAdminFaqContent = (faq) => faq.filter((faqItem) => faqItem.role === "Common");
const sortFaq = (faqA, faqB) => faqA.sortOrder - faqB.sortOrder;
